import { supabase } from '@/integrations/supabase/client';

// Add the UserSettingsRow interface
export interface UserSettingsRow {
  id: string;
  user_id: string;
  calorie_goal: number;
  walking_goal: number;
  fasting_goal: number;
  sleep_goal: number;
  water_goal: number;
  water_unit: 'ml' | 'oz';
  created_at: string;
  updated_at: string;
}

// Ensure we properly handle user settings data
export async function getUserSettings(userId: string, defaultValue = null) {
  try {
    const { data, error } = await supabase
      .from('user_settings')
      .select('*')
      .eq('user_id', userId)
      .single();
    
    if (error) {
      if (error.code === 'PGRST116') {
        // No settings found, return default
        return defaultValue;
      }
      throw error;
    }
    
    if (!data) return defaultValue;
    
    const userSettings = data as UserSettingsRow;
    
    // Map the settings to our application format
    return {
      calorieGoal: userSettings.calorie_goal || 2000,
      walkingGoal: userSettings.walking_goal || 30,
      fastingGoal: userSettings.fasting_goal || 16 * 60 * 60 * 1000,
      sleepGoal: userSettings.sleep_goal || 8.0,
      waterGoal: userSettings.water_goal || 2000,
      waterUnit: userSettings.water_unit || 'ml',
      profileId: userSettings.id
    };
  } catch (error) {
    console.error("Error fetching user settings:", error);
    return defaultValue;
  }
}
